<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  
  <div class='global-panel' v-loading.body="loading.main">
    <div class='global-header'>
      <div class='global-title'>Session管理(单点登录无效)</div>
      <div class='global-tbar'>
        <el-input size="small" placeholder="登录名" v-model="condition.userName"></el-input>
        <el-input size="small" placeholder="用户名" v-model="condition.realName"></el-input>
        <el-button size="small" type="default" @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <div class="global-paging" v-show="paging.allNum > paging.everySize" >
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
      <el-table :data="systemSessions" border stripe style="width: 100%" size="mini">
        <el-table-column prop="userName" label="登录名" width="200"></el-table-column>
        <el-table-column prop="realName" label="用户名" width="200"></el-table-column>
        <el-table-column prop="activeNum" label="活动数" width="200"></el-table-column>
        <el-table-column label="操作" width="300" align="center">
        <template slot-scope="scope">
          <el-button class="global-text-btn-danger" size="mini" type="text" @click="kickOut(scope.row)" style="margin-left: 10px;">踢出</el-button>
        </template>
        </el-table-column>
      </el-table>
      <div class="global-paging" v-show="paging.allNum > paging.everySize" >
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'SystemSessionIndex',
  data () {
    return {
      // 系统邮件列表
      systemSessions: [],
      // 遮罩
      loading: {main: false},
      // 可见
      visible: {},
      // 条件
      condition:{},
      // 分页
      paging: {currPage: 1, everySize: 20, allNum: 0}
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';

    vm.findByCondition();
  },
  
  methods: {
    /*
     * 查询所有
     */
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      // 请求后台
      vm.$http.get('rest/sys/systemSession/findByCondition', {params: params}).then(response => {
        vm.systemSessions = response.body.systemSessions;
        vm.paging = response.body.pagingBean;
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    /*
     * 踢出
     */
    kickOut: function (record) {
      var vm = this;
      vm.$confirm('确定要踢出[' + record.userName+'_'+record.realName + ']的用户吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.post('rest/sys/systemSession/kickOut/'+String(record.userName)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition(vm.paging.currPage)
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/system/systemsession/SystemSessionIndex.vue